import { EChartsType, BarSeriesOption } from 'echarts';
import { EChartsOption } from 'echarts-for-react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { BarChart } from 'echarts/charts';
import * as echarts from 'echarts/core';
import { XAXisOption, YAXisOption } from 'echarts/types/dist/shared';

type BarChartType = {
  data: BarSeriesOption[];
  xAxis: XAXisOption | XAXisOption[];
  yAxis?: YAXisOption | YAXisOption[];
  height?: number;
  chartOptions?: object;
  className?: string;
  onChartReady?: (chart: EChartsType) => void;
};

echarts.use([BarChart]);

const CustomBarChart = (props: BarChartType) => {
  const {
    data,
    xAxis,
    yAxis,
    height = 194,
    chartOptions = {},
    className = '',
    onChartReady,
  } = props;

  const chartData: BarSeriesOption[] = data.map((d: BarSeriesOption) => {
    return {
      ...d,
      type: 'bar',
      barCategoryGap: 0.5,
      barWidth: d.barWidth ?? '18.5px',
    };
  });

  const options: EChartsOption = {
    grid: {
      right: 0,
      left: 0,
      containLabel: true,
    },
    height: height,
    overflow: 'auto',
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    textStyle: {
      fontFamily: 'Inter',
    },
    xAxis: xAxis,
    yAxis: yAxis,
    series: chartData,
    ...chartOptions,
  };

  return (
    <div style={{ width: '100%', height: `${height + 150}px` }}>
      <ReactEChartsCore
        echarts={echarts}
        className={className}
        option={options}
        notMerge={true}
        lazyUpdate={true}
        onChartReady={e => onChartReady && onChartReady(e)}
      />
    </div>
  );
};

export default CustomBarChart;
